// Copyright 2025 Sorama B.V.

import { LicenseBundle, LicenseKind } from "datatypes/SoramaWebApi";
import { PackageFileInfo } from "services/Hardware/CamHTTP/ICamApi";

export abstract class ILicenseBundleService {
    public abstract getOwnedLicenseBundlesForDevice(deviceId: string): Promise<LicenseBundle[]>;
    public abstract getActiveBundlesLicenseKinds(deviceId?: string): Promise<LicenseKind[]>;
    public abstract getSignedLicenseBundle(bundleId: string, hardwareClock: number): Promise<string>;
    public abstract getPackageFile(deviceId: string): Promise<PackageFileInfo>;
}
